import validate from 'lib/utils/validationRules';

import logrocket from '@/services/logrocket';

import { update as updateApi } from 'services/api/project';

export const update = async (payload) => {
  try {
    const { data } = await updateApi(payload);
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

// Сервис для работы с объектом проекта
const ProjectService = {

  checkPersonalProject(project) {
    return project?.type === 'PERSONAL';
  },

  checkPartnerProject(project) {
    return project?.type === 'PARTNER';
  },

  checkCanUseCabinet(project) {
    return project?.status === 'ACTIVE' || project?.status === 'PENDING' || false;
  },

  checkInactiveStatus(project) {
    return project?.status === 'INACTIVE';
  },

  checkValidated(project) {
    return project?.validated || false;
  },

  checkEnabledPayoutPermission(project) {
    return project?.cardPayoutPermission === 'ENABLED';
  },

  checkPaymentsEnabled(project) {
    return project?.paymentsEnabled || false;
  },

  checkPayoutsEndbled(project) {
    return project?.payoutsEnabled || false;
  },

  checkPeriodicRecurrentPaymentPermission(project) {
    return project?.periodicRecurrentPaymentPermission || false;
  },

  checkRecurrentPaymentPermission(project) {
    return project?.recurrentPaymentPermission || false;
  },

  checkMakerPublishingPermission(project) {
    return project?.makerPublishingPermission || false;
  },

  checkExternalCheckoutProvider(project) {
    if (!validate.isObjectWithFields(project, ['provider'])) {
      return false;
    }

    return project.provider?.code === '97ff3d29-4500-405f-98e2-d9f18bc423d1';
  },

  checkProviderCheckoutPay(project) {
    if (!validate.isObjectWithFields(project, ['provider'])) {
      return false;
    }

    return project.provider?.checkoutPay || false;
  },

  getProviderShopKey(project) {
    if (!validate.isObjectWithFields(project, ['provider'])) {
      return null;
    }

    return project.provider?.shopKey || null;
  },

  checkCurrencyChangePermission(project) {
    return project?.currencyChangePermission || false;
  },

  checkSubscriptionsPermission(project) {
    if (ProjectService.checkPeriodicRecurrentPaymentPermission(project)) {
      return true;
    }

    if (!ProjectService.checkRecurrentPaymentPermission(project)) {
      return false;
    }

    if (!validate.isObjectWithFields(project, ['subscriberCount'])) {
      return false;
    }

    return project.subscriberCount?.all > 0;
  },

  checkEmptyCurrency(project) {
    return validate.isUndefined(project.currency) || validate.isNull(project.currency);
  },

  checkRussianCurrency(project) {
    if (ProjectService.checkEmptyCurrency(project)) {
      return false;
    }

    return project.currency?.code === 'RUB';
  },

  checkCryptoCurrency(project) {
    if (ProjectService.checkEmptyCurrency(project)) {
      return false;
    }

    return project.currency?.type === 'CRYPTO';
  },
};

export default ProjectService;
